import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {DadosService } from './dados.service';
import { HttpModule } from '@angular/http';

@NgModule({
  imports: [
    CommonModule
  ],
  providers:[
    DadosService,HttpModule,
  ],
  exports:
  [
   
  ],
  declarations: []
})
export class DbModule { }
